export default "__VITE_ASSET__DJCEI4HE__"